import { ReactNode } from 'react';
import IconEmailAlerts from '@creditflowresearch/uilib/Icon/IconEmailAlerts';
import IconEmailChecked from '@creditflowresearch/uilib/Icon/IconEmailChecked';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Button from '@creditflowresearch/uilib/Button';

interface IProps {
  tooltip: ReactNode,
  onClick: () => void,
  isDisabled: boolean,
  isTooltipDisabled?: boolean,
  isFetching?: boolean,
  isSubscribed?: boolean,
  dataTest?: string,
  className?: string,
}

const SubscribeButton = ({
  tooltip,
  onClick,
  isDisabled,
  isTooltipDisabled,
  isFetching,
  isSubscribed,
  dataTest,
  className,
}: IProps) => (
  <Tooltip content={ tooltip } disabled={ isTooltipDisabled }>
    <Button
      variant="outline"
      size="S"
      icon={ isSubscribed ? <IconEmailChecked /> : <IconEmailAlerts /> }
      onClick={ onClick }
      disabled={ isDisabled }
      loading={ isFetching }
      ariaLabel={ typeof tooltip === 'string' ? tooltip : undefined }
      dataTest={ dataTest || 'subscribeButton' }
      className={ className }
    />
  </Tooltip>
);

export default SubscribeButton;
